import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { isString } from '../lang';
import { SPLIT_NOT_FOUND } from '../labels';
import logFactory from '../logger';
var log = logFactory(''); // include BOM and nbsp

var TRIMMABLE_SPACES_REGEX = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/;
export function validateSplit(maybeSplit, method) {
  if (maybeSplit == undefined) {
    // eslint-disable-line eqeqeq
    log.error("".concat(method, ": you passed a null or undefined split name, split name must be a non-empty string."));
  } else if (!isString(maybeSplit)) {
    log.error("".concat(method, ": you passed an invalid split name, split name must be a non-empty string."));
  } else {
    if (TRIMMABLE_SPACES_REGEX.test(maybeSplit)) {
      var _context;
      log.warn(_concatInstanceProperty(_context = "".concat(method, ": split name \"")).call(_context, maybeSplit, "\" has extra whitespace, trimming."));
      maybeSplit = _trimInstanceProperty(maybeSplit).call(maybeSplit);
    }
    if (maybeSplit.length > 0) {
      return maybeSplit;
    } else {
      log.error("".concat(method, ": you passed an empty split name, split name must be a non-empty string."));
    }
  }
  return false;
}
/**
 * This is defined here and in this format mostly because of the logger and the fact that it's considered a validation at product level.
 * But it's not going to run on the input validation layer. In any case, the most compeling reason to use it as we do is to avoid going to Redis and get a split twice.
 */

export function validateSplitExistance(context, splitName, labelOrSplitObj, method) {
  if (context.get(context.constants.READY, true)) {
    // Only if it's ready we validate this, otherwise it may just be that the SDK is not ready yet.
    if (labelOrSplitObj === SPLIT_NOT_FOUND || labelOrSplitObj == null) {
      var _context2;
      log.warn(_concatInstanceProperty(_context2 = "".concat(method, ": you passed \"")).call(_context2, splitName, "\" that does not exist in this environment, please double check what Splits exist in the web console."));
      return false;
    }
  }
  return true;
}